import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const DISTANCE_BASED_ALERT_TOP_MARGIN = "-10px";

export const AlertContainer = styled.div<{
    isTurboVariantEnabled?: boolean;
    backgroundColor?: keyof IColors;
    customBackgroundColor?: string;
}>(({ theme, isTurboVariantEnabled, backgroundColor, customBackgroundColor }) => ({
    height: theme.spacing.xLarge,
    width: "100%",
    borderTopLeftRadius: theme.spacing.medium,
    borderTopRightRadius: theme.spacing.medium,
    backgroundColor:
        customBackgroundColor || (backgroundColor ? theme.colors[theme.colorMode][backgroundColor] : undefined),
    flexDirection: "row",
    zIndex: 1200,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginBottom: DISTANCE_BASED_ALERT_TOP_MARGIN,
    display: "flex",
    ...(isTurboVariantEnabled && {
        width: `calc(100% - ${theme.spacing.xSmall})`,
        marginInline: theme.spacing.xxSmall,
        borderRadius: theme.cornerRadius.xSmall,
        justifyContent: "flex-start",
        paddingBlock: theme.spacing.xSmall,
        height: theme.spacing.xxLarge,
        top: theme.spacing.xxSmall,
        marginBottom: theme.spacing.xxxSmall,
        zIndex: 0,
    }),
}));

export const StyledText = styled(Text)<{ isTurboVariantEnabled?: boolean }>(({ theme, isTurboVariantEnabled }) => ({
    marginTop: theme.spacing.xxSmall,
    ...(isTurboVariantEnabled && {
        marginLeft: theme.spacing.xxSmall,
        marginTop: 0,
    }),
}));

export const IconContainer = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.small,
}));
